// The SOW price of a catalogue product.
//
// A price somebody typed into SOW Price is the price. Left blank, the product
// sells at its cheapest supplier price plus commission: the product's own
// Commission Override % if it has one, else the catalogue default (the
// product_catalog_default_commission_pct setting). Nothing is written back, so
// the automatic price follows the supplier price as it changes, and clearing
// the SOW Price box hands a product back to it.

const round2 = (n) => Math.round(n * 100) / 100;

export const commissionPctOf = (product, defaultPct) =>
  product?.commission_pct != null && product.commission_pct !== '' ? Number(product.commission_pct) : Number(defaultPct);

// The automatic price, or null when no supplier has priced the product yet.
export function autoSellPrice(product, defaultPct) {
  if (product?.min_price == null || product.min_price === '') return null;
  return round2(Number(product.min_price) * (1 + commissionPctOf(product, defaultPct) / 100));
}

// { price, auto }: the typed price with auto false, else the automatic one.
export function sowPrice(product, defaultPct) {
  if (product?.sell_price != null && product.sell_price !== '') return { price: Number(product.sell_price), auto: false };
  const price = autoSellPrice(product, defaultPct);
  return { price, auto: price != null };
}
